<style scoped> 
    .label-custom{
        font-weight: 600;
        font-style: italic;
    }
</style>

<template>
	<div class="form-group">
        <label class="label">{{ $t("Other") }}</label>
        <input
            type="text"
            class="form-control"
            v-model="other"
            placeholder="Enter other"
            :disabled="is_view"
        />
	</div>
</template>
  
<script>
export default {
    name: 'Other',
    props: {
        value: {
            type: [String, Number, Object],
            default: null
        },
        is_view : {
            type : Boolean,
            default : false
        }
    },
    computed: {
        other: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    }
}
</script>